module.exports = __webpack_public_path__ + "static/media/MrWalkerStepsOut.ce09cedb.jpg";